import useEvents from 'hooks/useEvents';

import events from './events';
import type { MapEvent, MapEventListener, MapEventType } from './types';

const useMapEvents = () => {
    const {
        publish: globalPublish,
        subscribe: globalSubscribe,
        unsubscribe: globalUnsubscribe
    } = useEvents();

    const publish = (event: MapEvent) => {
        globalPublish(event);
    };

    const subscribe = (eventType: MapEventType, callback: MapEventListener) => {
        globalSubscribe({ callback, eventType });
    };

    const unsubscribe = (eventType: MapEventType, callback: MapEventListener) => {
        globalUnsubscribe({ callback, eventType });
    };

    return {
        eventFactory: events,
        publish,
        subscribe,
        unsubscribe
    };
};

export default useMapEvents;
